// ----------------------------------------------------------------------
// <copyright file="Izenda.Hue.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var domHelperEvents = require('dom-helpers/events');
  var ColorDialogUtils = require('./Izenda.ColorDialogUtils');

  var Hue = React.createClass({

    componentWillUnmount: function() {
      this.unbindEventListeners();
    },

    handleChange: function(e, skip) {
      var change = ColorDialogUtils.hueCalculateChange(e, skip, this.props, this.refs.container);
      change && this.props.onChange(change);
    },

    handleMouseDown: function(e) {
      this.handleChange(e, true);
      domHelperEvents.on(window, 'mousemove', this.handleChange);
      domHelperEvents.on(window, 'mouseup', this.handleMouseUp);
    },

    handleMouseUp: function() {
      this.unbindEventListeners();
    },

    unbindEventListeners: function() {
      domHelperEvents.off(window, 'mousemove', this.handleChange);
      domHelperEvents.off(window, 'mouseup', this.handleMouseUp);
    },

    render: function() {
      return (
        <div className="izenda-Hue">
          <div
            className="izenda-Hue-container"
            ref="container"
            onMouseDown={ this.handleMouseDown }
            onTouchMove={ this.handleChange }
            onTouchStart={ this.handleChange }
          >
            <div className="izenda-Hue-pointer">
              <div>
                <div className="izenda-Hue-left">
                  <div className="izenda-Hue-leftInside" />
                </div>

                <div className="izenda-Hue-right">
                  <div className="izenda-Hue-rightInside" />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  });

  module.exports = Hue;
}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/ColorDialog/Izenda.Hue.jsx